import { youkuVideoHandler } from "_fil_local_addon/camc-cms-video/camc-cms-single-youku-video";

// Helper function to safely re-initialize equalizers
const reInitializeEqualizers = (context = document, delay = 0) => {
    setTimeout(() => {
        const equalizerElements = $("[data-equalizer]", context);
        if (equalizerElements.length > 0) {
            Foundation.reInit("equalizer");
        }
    }, delay);
};

// Helper function to pause all videos in a given context
const pauseAllVideos = (context) => {
    try {
        // Pause HTML5 videos
        const videos = context.find("video");
        videos.each(function () {
            if (this.pause && typeof this.pause === "function") {
                this.pause();
            }
        });

        // Handle Youku videos by restoring to initial state
        const youkuContainers = context.find(".video-player-container.youku");
        youkuContainers.each(function () {
            const $container = $(this);
            const $youkuPlayer = $container.find(".youku-player");

            if ($youkuPlayer.length > 0) {
                // Store original content for restoration when showing again
                if (!$container.data("original-content")) {
                    $container.data("original-content", $container.html());
                }

                // Mark this container as having been processed for video pausing
                $container.data("video-was-paused", true);

                // Get the video ID and player ID for restoration
                const videoId = $youkuPlayer.attr("videoId");
                const playerId = $youkuPlayer.attr("id");

                if (videoId && playerId) {
                    // Clear the container to stop the video
                    $container.empty();

                    // Restore to initial state like in youku_video.html template
                    $container.html(`
                        <div class="video-player-youku">
                            <div id="${playerId}" class="youku-player" videoId="${videoId}">
                                <div class="single-youku-video__loader"></div>
                                <div class="single-youku-video__item" style="display: none;">
                                    <img class="single-youku-video__thumbnail" alt="youku-thumbnail" src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='>
                                    <div class="single-youku-video__play-mask"></div>
                                    <div class="single-youku-video__play-icon fil-icon fil-icon-play"></div>
                                </div>
                                <div class="single-youku-video__item single-youku-video__item--error" style="display: none;">
                                    <div class="single-youku-video__play-icon single-youku__play-icon--error fil-icon fil-icon-circle-arrow-back" style="font-family: fidelity-icon-font!important;"></div>
                                </div>
                            </div>
                        </div>
                    `);

                    // Re-initialize the youku video handler to restore initial state
                    const youkuObj = new youkuVideoHandler(playerId);
                    youkuObj.setup();
                }
            }
        });
    } catch (error) {
        console.warn("Failed to pause videos:", error);
    }
};

// Helper function to maintain toggler position when collapsing content
const maintainTogglerPosition = ($toggler, callback) => {
    try {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Get the content container to measure height change
        const $hiddenWrapper = $toggler.closest(".camc-show-hide-wrapper-inner--hidden");
        const $hiddenInnerWrapper = $hiddenWrapper.find(".hidden-wrapper");

        // Measure the height that will be removed
        const contentHeight = $hiddenInnerWrapper.outerHeight();

        // Create a temporary spacer to maintain document height during transition
        const $spacer = $("<div>").css({
            height: contentHeight + "px",
            opacity: 0,
            pointerEvents: "none",
        });

        // Insert spacer after the hidden wrapper
        $hiddenInnerWrapper.after($spacer);

        // Execute the callback (hide content)
        callback();

        // Calculate the target scroll position
        const targetScrollTop = Math.max(0, currentScrollTop - contentHeight);

        // Animate spacer height to 0 while adjusting scroll position
        $spacer.animate(
            { height: 0 },
            {
                duration: 0,
                complete: function () {
                    // Remove spacer when animation is complete
                    $spacer.remove();
                    // Final scroll adjustmentzzne

                    window.scrollTo(0, targetScrollTop);
                },
            },
        );
    } catch (error) {
        // Fallback: just execute the callback without position maintenance
        console.warn("Failed to maintain toggler position:", error);
        callback();
    }
};

$(() => {
    if ($(".camc-show-hide-wrapper").length > 0) {
        $(".camc-show-hide-wrapper").each((_, el) => {
            const $hiddenWrapper = $(".camc-show-hide-wrapper-inner--hidden", el);
            const $togglerDOM = $hiddenWrapper.find(".toggler");
            const $togglerLabelDOM = $togglerDOM.find(".label");
            const $hiddenInnerWrapper = $hiddenWrapper.find(".hidden-wrapper");
            const hideLabel = $togglerDOM.data("hide-label");
            const showLabel = $togglerLabelDOM.text();
            const canHide = hideLabel && hideLabel.length > 0;

            $togglerDOM.on("click", () => {
                if ($hiddenInnerWrapper.is(":hidden")) {
                    $hiddenInnerWrapper.removeClass("hide");

                    // Re-initialize equalizers
                    reInitializeEqualizers($hiddenInnerWrapper);

                    if (canHide) {
                        $togglerLabelDOM.text(hideLabel);
                        $togglerDOM.addClass("is-active");
                    } else {
                        $togglerDOM.addClass("hide");
                    }
                } else {
                    maintainTogglerPosition($togglerDOM, () => {
                        // Pause all videos before hiding content
                        pauseAllVideos($hiddenInnerWrapper);

                        $hiddenInnerWrapper.addClass("hide");
                        $togglerLabelDOM.text(showLabel);
                        $togglerDOM.removeClass("is-active");
                    });
                }
            });
        });
    }
});
